var str = Object.prototype.toString

module.exports = anArray

function anArray(arr) {
  return (
       arr.BYTES_PER_ELEMENT
    && str.call(arr.buffer) === '[object ArrayBuffer]'
    || Array.isArray(arr)
  )
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/an-array/index.js
// module id = 1986
// module chunks = 0